import { render, staticRenderFns } from "./TotalJointCommitment.vue?vue&type=template&id=978f9988"
import script from "./TotalJointCommitment.vue?vue&type=script&lang=js"
export * from "./TotalJointCommitment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports